module.exports = __webpack_public_path__ + "static/Nudista-1e0f5ef25dc300adfbb70fe12d9f1be9.ttf";